export default __webpack_public_path__ + "static/media/deny.1b149eb4.png";